import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/purple.png";
import fruit from "/cywe-assets/fruit/blackberry.png";

export default function Purple({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="He is Gentle, as a lamb!"
				description="Acting in purity of thought, caring about people’s hearts and souls. Respectful to people in their current life/belief systems without prejudice or judgement."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/7"
				next="/experience/9"
			/>
		</>
	);
}
